// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1216":"vendors","6377":"main"}[chunkId] + "." + {"1216":"9dbcef61","6377":"7f90ae8b"}[chunkId] + ".css";
};